import { render, staticRenderFns } from "./DevDates.vue?vue&type=template&id=1ec3505a"
import script from "./DevDates.vue?vue&type=script&lang=js"
export * from "./DevDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports